module.exports = __webpack_public_path__ + "packs/media/images/errors-images/505-error-f0574c71d7981980ac79f5f798278d53.png";